export default "__VITE_ASSET__Dnsb78sO__"